import { DriverCapturePanel } from '../components/DriverCapturePanel';

/** Record a step for the trip's driver, for the trip page. */
export function DriverCaptureSection({ tripId, driver }: { tripId: string; driver: { id: string; label: string } }) {
  return <DriverCapturePanel tripId={tripId} driver={driver} />;
}
